module.exports = __webpack_public_path__ + "static/media/Newdelhi.6bbcfcab.jpg";